module.exports = __webpack_public_path__ + "img/glasses-min.7d4eeff0.png";